<template>
    <div class="py-3 px-4 rounded-lg text-xs bg-[#DFF1DF] relative flex space-x-4">
        <div class="text-[18px]">
            <i class="fa-circle-info fa-solid text-[#00B612]"></i>
        </div>
        <slot></slot>
    </div>
</template>
<script lang="ts" setup></script>
